import { Link } from "react-router-dom";
import { Shield } from "lucide-react";
import { useCookieConsentOptional } from "../context/CookieConsentContext";

/**
 * Placeholder cuando el visitante no ha aceptado cookies de terceros.
 * Si allowOnce, muestra botón para aceptar solo terceros y cargar.
 */
export default function ConsentAwareEmbed({
  title = "Contenido de terceros",
  description = "Este bloque carga servicios externos (p. ej. YouTube, Maps o Heyzine) que pueden usar cookies.",
  className = "",
  minHeight = "16rem",
  children,
}) {
  const consent = useCookieConsentOptional();
  const allowed = consent?.thirdPartyAllowed;

  if (allowed) {
    return children;
  }

  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 rounded-[28px] border border-brand-soft bg-brand-soft/40 text-center px-6 py-10 ${className}`}
      style={{ minHeight }}
      role="region"
      aria-label={title}
    >
      <div className="w-11 h-11 rounded-xl bg-white flex items-center justify-center text-brand-primary">
        <Shield size={22} />
      </div>
      <p className="font-display font-bold text-brand-dark text-base">{title}</p>
      <p className="text-sm text-brand-dark/65 max-w-md leading-relaxed">{description}</p>
      <div className="flex flex-wrap items-center justify-center gap-2 mt-1">
        <button
          type="button"
          onClick={() =>
            consent?.savePreferences({
              functional: consent.consent.functional,
              analytics: consent.consent.analytics,
              thirdParty: true,
            })
          }
          className="px-4 py-2.5 rounded-xl bg-brand-primary text-white text-xs font-bold uppercase tracking-wider"
        >
          Activar contenido
        </button>
        <button
          type="button"
          onClick={() => consent?.openPreferences()}
          className="px-4 py-2.5 rounded-xl border border-brand-primary text-brand-primary text-xs font-bold uppercase tracking-wider"
        >
          Configurar cookies
        </button>
        <Link
          to="/cookies"
          className="text-xs font-semibold text-brand-dark/55 underline underline-offset-2"
        >
          Política de cookies
        </Link>
      </div>
    </div>
  );
}
